import { ReactNode } from "react"

export interface PaywallSplitSectionProps {
  leftContent: ReactNode
  rightContent: ReactNode
}

const PaywallSplitSection = ({
  leftContent,
  rightContent,
}: PaywallSplitSectionProps) => (
  <div
    className="bg-sand h-auto xl:h-[900px] flex justify-center items-center py-18 xl:py-0"
    data-testid="paywall-split-section"
  >
    <div className="container max-w-[1440px] flex flex-col xl:flex-row justify-between gap-9 xl:gap-[54px]">
      <div className="w-full">{leftContent}</div>

      <div className="w-full xl:max-w-[420px] xl:pr-14">{rightContent}</div>
    </div>
  </div>
)

export default PaywallSplitSection
